import React from 'react';
import Tag from '@components/ui/Tag.tsx';
import { ColorSchema, ColorVariant, SizeVariant } from '@utils/types.ts';
import { useTranslation } from 'react-i18next';
import { PriceTypeCode } from './priceTypeCodes';

interface Props {
  code: PriceTypeCode;
  /** 'full' = "GC – Vysoutěžená" (default), 'short' = jen zkratka s tooltipem (husté tabulky). */
  variant?: 'full' | 'short';
  size?: SizeVariant;
}

const codeStyle: Record<PriceTypeCode, { color: ColorVariant; colorSchema: ColorSchema }> = {
  GC: { color: 'secondary', colorSchema: 'dark' },
  NC: { color: 'neutral', colorSchema: 'light' },
  AC: { color: 'secondary', colorSchema: 'light' },
  NP: { color: 'secondary', colorSchema: 'light' },
  VP: { color: 'primary', colorSchema: 'light' },
  DL: { color: 'secondary', colorSchema: 'light' },
};

/** Jednotné zobrazení typu položky - stejné zkratky jako v objednávkovém PDF. */
const PriceTypeCodeTag: React.FC<Props> = ({ code, variant = 'full', size = 'xs' }) => {
  const { t } = useTranslation('client');

  const label = t(`priceTypeCodes.${code}`);
  const style = codeStyle[code];

  return (
    <span title={`${code} – ${label}`}>
      <Tag
        text={variant === 'short' ? code : `${code} – ${label}`}
        color={style.color}
        colorSchema={style.colorSchema}
        componentState="default"
        size={size}
      />
    </span>
  );
};

export default PriceTypeCodeTag;
